import { render, staticRenderFns } from "./Phase3Container.vue?vue&type=template&id=5ff2326a&scoped=true&"
import script from "./Phase3Container.vue?vue&type=script&lang=js&"
export * from "./Phase3Container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2326a",
  null
  
)

export default component.exports